<template>
  <div class="book-size-info">
    <div v-if="showAudioBookSize" class="text-small d-flex align-items-center">
      <HeadphonesIcon class="headphones-icon" width="20" height="20" />
      <span class="ml-8">
        {{ audioBookDuration }} {{ $label('common.hour') }}
      </span>
      <span class="text-grey">
        &nbsp;({{ audioBookFileSize }}{{ $label('common.fileSize.MB') }})
      </span>
    </div>
    <div v-if="showEbookSize" class="text-small d-flex align-items-center">
      <BookFlipPageIcon class="book-icon" width="20" height="20" />
      <span class="ml-8">
        {{
          $label('page.book.pageCount_plural', {
            count: numberOfPages,
          })
        }}
      </span>
      <span class="text-grey">
        &nbsp;({{ ebookFileSize }}{{ $label('common.fileSize.MB') }})
      </span>
    </div>
  </div>
</template>

<script>
import BookFlipPageIcon from '~/assets/icons/book-open.svg'
import HeadphonesIcon from '~/assets/icons/headphones.svg'

export default {
  components: {
    BookFlipPageIcon,
    HeadphonesIcon,
  },
  props: {
    book: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ebookFileSize() {
      const fileSize = this.book.download?.ebook
        ? this.book.download.ebook.fileSize
        : this.book.fileSize

      return fileSize ? this.round(fileSize / 1e6, 1) : 0
    },
    audioBookFileSize() {
      const audioBook = this.book.download?.audioBook

      return audioBook ? this.round(audioBook.fileSize / 1e6, 1) : 0
    },
    audioBookDuration() {
      const { audioBook } = this.book.download
      const durationInMinutes = 60 * 60

      return audioBook ? this.round(audioBook.duration / durationInMinutes) : 0
    },
    numberOfPages() {
      return this.book.download?.ebook
        ? this.book.download.ebook.numberOfPages
        : this.book.numberOfPages
    },
    showEbookSize() {
      return this.ebookFileSize && this.numberOfPages
    },
    showAudioBookSize() {
      return this.audioBookFileSize && this.audioBookDuration
    },
  },
  methods: {
    round(value, precision) {
      const multiplier = Math.pow(10, precision || 0)
      return Math.round(value * multiplier) / multiplier
    },
  },
}
</script>

<style lang="scss" scoped>
.book-size-info {
  display: flex;
  flex-direction: row;

  .text-small:nth-child(2) {
    margin-left: 24px;
    margin-bottom: 0;
  }
}

.text-grey {
  color: $black;
  opacity: 0.3;
}
</style>
